import { render, staticRenderFns } from "./LangChoose.vue?vue&type=template&id=b7feec40&scoped=true&"
import script from "./LangChoose.vue?vue&type=script&lang=js&"
export * from "./LangChoose.vue?vue&type=script&lang=js&"
import style0 from "./LangChoose.vue?vue&type=style&index=0&id=b7feec40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7feec40",
  null
  
)

export default component.exports